import { Grid } from '@mui/material';
import { ReactNode } from 'react';

import { CopyButton } from '../../../components/general/CopyButton.tsx';
import { HeadingWithTag } from '../../../components/general/HeadingWithTag.tsx';
import { AccordionWithHeading } from '../../../components/general/index.ts';
import { LabelValue } from '../../../components/general/LabelValue.tsx';
import { type ThemaFromThemaRouter } from '../../../dtos.ts';
import { formatDate, printWithNoInfo } from '../../../utils/index.ts';

type ThemaEigenschaftenCardProps = {
  readonly thema: ThemaFromThemaRouter;
};

const printAvendooKursfreigabeId = (thema: Pick<ThemaFromThemaRouter, 'avendooKursfreigabeId'>): ReactNode =>
  thema.avendooKursfreigabeId ? (
    <>
      {thema.avendooKursfreigabeId}
      {thema.avendooKursfreigabeId && <CopyButton text={thema.avendooKursfreigabeId} />}
    </>
  ) : null;

export const ThemaEigenschaftenCard = (props: ThemaEigenschaftenCardProps) => {
  const { thema } = props;

  const data = [
    ['AKA-Produkt-ID', printWithNoInfo(thema.akaProduktId)],
    ['SAP-Produkt-ID', thema.produktSapId.toString()],
    ['Avendoo-Kursfreigabe-ID', printAvendooKursfreigabeId(thema)],
    ['Sprache', thema.sprachen.join(', ')],
    ['Letzte Änderung in Viva', formatDate(thema.updatedAt, true)],
  ] as const;

  return (
    <AccordionWithHeading heading={<HeadingWithTag heading={'Eigenschaften'} tag="cserv" />} noAccordion>
      <Grid container spacing={2}>
        {data.map(([label, value]) => (
          <Grid key={label} size={{ xs: 4 }}>
            <LabelValue label={label} value={value} />
          </Grid>
        ))}
      </Grid>
    </AccordionWithHeading>
  );
};
